import React, { useState } from 'react';
import { SearchDropdown } from '@prosolve/common-components-ui';

export default ({
  value = '',
  assessmentNames = [],
  excludeName,
  emptyText = 'None',
  onChange,
  disabled,
  width = '300px'
}) => {
  const [searchText, setSearchText] = useState('')

  const names = assessmentNames.filter(name => name && name !== excludeName);

  // Keep a saved name visible even if that assessment no longer exists
  if (value && !names.includes(value)) {
    names.push(value);
  }

  const allOptions = [
    { value: '', text: emptyText },
    ...names.map(name => ({ value: name, text: name }))
  ];

  const search = searchText.trim().toLowerCase();
  const options = search
    ? allOptions.filter(({ text }) => text.toLowerCase().includes(search))
    : allOptions;

  return (
    <SearchDropdown
      options={options}
      value={value}
      onChange={(newValue) => {
        if (newValue !== value) {
          onChange(newValue)
        }
      }}
      onSearch={setSearchText}
      searchDelay={200}
      width={width}
      maxHeight='200px'
      placeholder='Type to search assessments...'
      disabled={disabled}
    />
  )
}
